var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_vm._l((_vm.params.value),function(data){return [_c('div',{key:data.id},[_c('li',[_vm._v("data.title")]),_c('br')])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }